<template>
  <div>
    <div class="ibox-content add_padding_mop_common " style="padding: 16px" >
        <div>
          <div class="fieldworker_messages"></div>
            <span class="select-services-dropdown-title">
              Available {{ labelWorkersName }}
          </span>
        </div>
        <div :class="{'details-container':true , 'm-top-12':0>0}">
          <div class="row m-right-0 m-left-0 mobile-p-bottom-0">
            <button v-if="itemType=='booking'" class="btn btn-primary"
                    data-toggle="modal" data-target="#fn_nearest" href="#" @click="handleNearestBooking">
              <i class="glyphicon glyphicon-map-marker"></i> Nearby bookings
            </button>
            <button v-if="itemType=='booking'" class="btn btn-primary"
                    data-toggle="modal" data-target="#fn_nearest" href="#" @click="handleFindAvailability">
              <i class="fa fa-calendar"></i> Find availability
            </button>
            <div v-if="itemType=='booking'" class="btn-group mobile-p-top-5">
              <a class="btn btn-primary"  data-toggle="modal" data-target="#sms-job-request-modal1">
                <i class="fa fa-repeat"></i> Send job request
              </a>
            </div>
            <i ref="toggleIcon" class="fa fa-chevron-down rotate float-right cursor-pointer" style="color: #2E4051;font-size: 18px;"
               @click="toggleCollapse"></i>
          </div>

          <div class="row"  >
            <div class="col-md-8">
              <a class="btn btn-white filters-icon-btn fc-filters-button pull-left white-space-inherit" data-toggle="modal" data-target="#available-filters-popup">
                <span class="filters-btn-span"><i class="fa fa-sliders"></i> Filters</span>
              </a>
            </div>
            <div class="available-count col-md-4" @click="toggleCollapse">
                <div class="col-md-12">
                    <div class="gray-text m-top-6 laptop-position float-right">
                        <strong>{{ availableFieldworkers.length }}</strong>
                        <strong data-v-30a831cc="">available</strong>
                    </div>
                </div>
            </div>
          </div>

          <div :class="{'collapsed': isCollapsed}">
            <div class="row available-section" >
              <available-fieldworkers-table
                :contractorDistances="availableFieldworkers"
                :available_data="available_data"
                :countActiveServices="filters.active_service_ids.length"
                :booking-id="itemId"
                :item-type="itemType"
                :show-address="showAddress"
                :line-address="lineAddress"
                :booking-address="bookingAddress"
                :is-address="isAddress"
                :is-collapsed="isCollapsed"
                :is-first-time="isFirstTime"
                :available-contractors ="availableContractors"
              ></available-fieldworkers-table>
            </div>
          </div>
        </div>
        <available-fieldworkers-filters ref="filters_form" v-model="filters" :all_service_attributes="all_service_attributes" :active_services="active_services"
                 :available_data="available_data" :allLabels="allLabels" @submit-available="getAvailableFieldworkersSection"></available-fieldworkers-filters>
        <job-request-form v-if="itemType=='booking'" ref="jobRequestForm" :availableFieldworkers="availableFieldworkers" :bookingServices="active_services" :available_data="available_data"
                          :twilio_sms_active="available_data?available_data.twilio_sms_active:false"
                          :user_os="available_data?available_data.user_os:'web'" :smsMessage="available_data?available_data.smsMessage:''"
                          @changeSmsServices="getAvailableFieldworkersSection(false,true)"></job-request-form>

  </div>
  </div>
</template>

<script>
import AvailableFieldworkersTable from "./AvailableFieldworkersTable.vue";
import {getAvailableFieldworkersData} from "@/modules/Booking/api/availableFieldworkers";
import AvailableFieldworkersFilters from "./AvailableFieldworkersFilters.vue";
import {EventBus} from "../../../../events/event-bus";

export default {
  name: "AvailableFieldworkers",
  components: {AvailableFieldworkersFilters, AvailableFieldworkersTable},
  props: {
    itemType: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    labelWorkersName: {
      type: String
    },
      lineAddress: {
          type: Array,
          required: false,
          default() {
              return []
          }
      },
      bookingAddress: {
          type: Array,
          required: false,
          default() {
              return []
          }
      },
      availableContractors: {
          type: Array,
          required: false,
          default() {
              return []
          }
      },
      showAddress: {
          required: false
      },
    isAddress:false,
    allLabels: null
  },
  data(){
    return {
      isCollapsed: true,
      isFirstTime: false,
      filters: {
        keywords: "",
        active_service_ids: [],
        service_attributes: [],
        active: "TRUE",
        label_ids: [],
        radius: 0,
        filter_by_radius: 1,
        check_real_time_availability: 0
      },
      availableFieldworkers: [],
      available_data: null,
      all_service_attributes: [],
      active_services: [],
      nearestBookingParams: "",
      nearestBookingUrl: "",
      findAvailabilityParams: "",
      findAvailabilityUrl: "",
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      if(!this.isFirstTime){
          this.isFirstTime = true;
      }
      $(this.$refs.toggleIcon).toggleClass('rotate-180')
    },
    getAvailableFieldworkersSection(withoutFltr=false,isJobRequest=false){
      let params = {
        item_type: this.itemType,
        item_id: this.itemId,
        fltr: this.filters,
      }
      if(withoutFltr)
        delete params['fltr']
      if(isJobRequest){
        // $('.available-job_request').find(".table-responsive").LoadingOverlay("show");
        params.sms_service_ids = $("#sms_service_ids").val()
      }
      // else
      //   $('.available-section').LoadingOverlay("show");

      getAvailableFieldworkersData(params).then(response => {
              if(isJobRequest){
                  this.$refs.jobRequestForm.changeAvailableContractors(response.data.contractors)
                  // $('.available-job_request').find(".table-responsive").LoadingOverlay("hide");
                  return
              }else
                  this.availableFieldworkers = response.data.contractors

              this.available_data = {...response.data.available_data,...{itemType: this.itemType, itemId: this.itemId}}
              if(withoutFltr)
                  this.filters = {...this.filters,...response.data.filters}//Merge filters
              else
                  this.isCollapsed = false
              this.all_service_attributes = response.data.all_service_attributes
              this.active_services = response.data.active_services
              this.nearestBookingParams = response.data.nearestBookingParams
              this.nearestBookingUrl = response.data.nearestBookingUrl
              this.findAvailabilityParams = response.data.findAvailabilityParams
              this.findAvailabilityUrl = response.data.findAvailabilityUrl
              // $('.available-section').LoadingOverlay("hide");
              this.$nextTick(function(){
                  this.$refs.filters_form.fillFltrButton()
              })
          })

    },
    handleFindAvailability(event){
      window.fn_popupi_with_parm('Find Availability', this.findAvailabilityUrl, this.findAvailabilityParams,event.target)
    },
    handleNearestBooking() {
      window.fn_popupi_with_parm('Nearest bookings', this.nearestBookingUrl, this.nearestBookingParams)
    },
  },
  mounted(){
    this.getAvailableFieldworkersSection(true);
      EventBus.$on('updateBookingLocationsOnAvailableFieldworker', () => {
          this.getAvailableFieldworkersSection(true)
      })

      EventBus.$on('sendingRequestAndUpdateDataTable', () => {
          this.getAvailableFieldworkersSection(true)
      })

  },
}
</script>
<style scoped>
.details-container {
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #EAECEE;
  margin-top: 12px;
}
.collapsed {
  display: none;
}
.rotate {
  -moz-transition: all 0.5s linear;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
}
.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
  -webkit-transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
  transform: rotate(-180deg);
  display: inline-block;
}
.available-count{
  text-align: center;
}
.white-space-inherit {
    white-space: inherit;
}
@media (max-width: 768px) {
    .mobile-p-top-5 {
        padding-top: 5px;
    }
    .mobile-p-bottom-0 {
        padding-bottom: 0px;
    }
}
</style>